// ResultsList — Presentational list of restaurant results: the pluralized
// count, the Hide/Show toggle, and a RestaurantCard per result.
//
// Extracted VERBATIM from `components/RestaurantSearch.js` (behavior-preserving
// refactor, issue #240). Render-only, wrapped in React.memo. Markup, styles,
// icons, text, pluralization, and the hover handlers are identical to the
// source.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';
import RestaurantCard from '../../RestaurantCard';

export const ResultsList = React.memo(function ResultsList({
  restaurants, isCollapsed, setIsCollapsed, trip, userProfile, onReservationCreated
}) {
  return (
    <div>
      <div style={{
        display: 'flex', justifyContent: 'space-between',
        alignItems: 'center', marginBottom: '16px'
      }}>
        <div style={{ fontSize: '14px', color: '#6b7280', fontWeight: '500' }}>
          Found {restaurants.length} restaurant{restaurants.length !== 1 ? 's' : ''}
        </div>
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          style={{
            padding: '6px 12px', border: '1px solid #d1d5db', borderRadius: '6px',
            backgroundColor: '#ffffff', cursor: 'pointer', display: 'flex',
            alignItems: 'center', gap: '6px', color: '#6b7280',
            fontSize: '13px', transition: 'all 0.2s'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#f9fafb';
            e.target.style.borderColor = '#9ca3af';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = '#ffffff';
            e.target.style.borderColor = '#d1d5db';
          }}
        >
          {isCollapsed ? (
            <>
              <ChevronDown size={16} />
              <span>Show Results</span>
            </>
          ) : (
            <>
              <ChevronUp size={16} />
              <span>Hide Results</span>
            </>
          )}
        </button>
      </div>
      {!isCollapsed && restaurants.map((restaurant) => (
        <RestaurantCard
          key={restaurant.id}
          restaurant={restaurant}
          trip={trip}
          userProfile={userProfile}
          onReservationCreated={onReservationCreated}
        />
      ))}
    </div>
  );
});

export default ResultsList;
